import { Link } from "react-router-dom";

export default function AccessDeniedPage() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-background-50 px-4 text-center">
      <span className="flex h-16 w-16 items-center justify-center rounded-2xl bg-danger-100 text-danger-600">
        <i className="ri-lock-2-line text-3xl" />
      </span>
      <h1 className="mt-6 text-5xl font-bold text-foreground-950">403</h1>
      <p className="mt-2 text-base font-medium text-foreground-900">Access denied</p>
      <p className="mt-1 max-w-sm text-sm text-foreground-500">
        You don't have permission to view this page. Contact your administrator if you believe this is a mistake.
      </p>
      <Link
        to="/"
        className="mt-6 inline-flex h-9 items-center gap-2 rounded-md bg-primary-500 px-4 text-sm font-medium text-white hover:bg-primary-600"
      >
        <i className="ri-arrow-left-line" /> Back to dashboard
      </Link>
    </div>
  );
}